import { Component, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonRecipeModel } from 'src/app/model/common/recipe';
import { CommonRecipeViewModel } from '../../../model/common/recipe-view';
import { RECIPE_CONSTANTS } from './general-recipe.constants';
import { GeneralRecipeService } from './general-recipe.service';

@Component({
  selector: 'ms-consult-recipe',
  templateUrl: './general-recipe.component.html',
  styleUrls: ['./general-recipe.component.scss'],
})
export class GeneralRecipeComponent extends BaseComponent {
  readonly screen = RECIPE_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
  recipe: CommonRecipeModel[] = [];
  toRemove: number[] = [];
  generatingFile = false;
  recipeFile?: SafeResourceUrl;
  showRecipePdf = false;

  selected?: CommonRecipeViewModel;
  suggestions: CommonRecipeViewModel[] = [];
  expandSection = true;

  constructor(protected service: GeneralRecipeService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service
        .loadRecipeInfo(this.turn)
        .subscribe((recipe) => (this.recipe = recipe))
    );
    if (!this.readonly) {
      this.subscriptions.push(
        this.service.isSaving().subscribe((saving) => {
          if (saving) {
            const recipe = this.recipe.filter(
              (recipeItem) =>
                recipeItem.medicineHelp &&
                recipeItem.medicineHelp.instructions != null &&
                recipeItem.medicineHelp.instructions !== ''
            );
            this.subscriptions.push(
              this.service
                .save(this.turn, recipe, this.toRemove)
                .subscribe(this.saveResult)
            );
          }
        })
      );
    }
  };

  removeRecipe = (idx: number) => {
    if (this.recipe[idx].id) {
      this.toRemove.push(this.recipe[idx].id!);
    }
    this.recipe.splice(idx, 1);
  };

  addUpdateRecipe = (recipe: CommonRecipeModel) => {
    if (recipe.id) {
      this.recipe.forEach((item, idx) => {
        if (item.id === recipe.id) {
          this.recipe[idx] = recipe;
        }
      });
    }
  };

  generateRecipe = () => {
    this.generatingFile = true;
    const recipe = this.recipe.filter(
      (recipeItem) =>
        recipeItem.medicineHelp &&
        recipeItem.medicineHelp.instructions != null &&
        recipeItem.medicineHelp.instructions !== ''
    );
    this.subscriptions.push(
      this.service
        .save(this.turn, recipe, this.toRemove)
        .subscribe((result) => {
          this.saveResult(result);
          this.subscriptions.push(
            this.service.generateRecipe(this.turn).subscribe((resource) => {
              this.showRecipePdf = true;
              this.recipeFile = resource;
              this.generatingFile = false;
            })
          );
        })
    );
  };

  handleSearchSuggestions = ({ query }: any) => {
    if (query?.length > 3) {
      this.service.getByQuery(query).subscribe((res) => {
        this.suggestions = res;
      });
    }
  };

  handleMedicineSelected = ({
    atcId: atc,
    turn,
    name,
    quantity,
    instructions,
  }: CommonRecipeViewModel) => {
    let medicine = '';
    if (instructions) {
      medicine = name!;
    }
    this.recipe.push({
      medicineHelp: {
        atc,
        name: medicine,
        quantity,
        instructions,
      },
    });
    this.selected = undefined;
  };

  private saveResult = (result: CommonRecipeModel[]) => {
    this.recipe = result.filter(
      (res) => !this.toRemove.find((removed) => removed === res.id)
    );
    this.toRemove = [];
  };
}
